export { default } from './ForecastDayTablePaywall';
